import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/[locale]/not-found.tsx");
